import React, { useState } from 'react';

import { useIntl } from 'react-intl';
import styled from 'styled-components';

import Checkbox from '@lib/inputs/Checkbox';
import useAppDispatch from '@hooks/useAppDispatch';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { communicationPreferencesTypes } from '@constants/individualPortal/preferences/preferenceTypes';
import { updateCommunicationPreferenceConfirmation } from '@actions/individualPortal/preferences/communicationPreferencesActionCreators';

interface PreferencesConfirmationProps {
    type: communicationPreferencesTypes;
    householdId: string;
    resetCommunicationPrefCount: () => {};
}

const StyledPreferenceContainer = styled.div`
    display: flex;
    align-items: center;
    margin-bottom: 10px;

    svg {
        margin: 0 10px;
    }

    .gi-checkbox__label {
        margin-bottom: 0;
    }

    .gi-checkbox {
        margin-bottom: 0;
        margin-top: 0;
    }
`;

function PreferencesConfirmation({ type, householdId, resetCommunicationPrefCount }: PreferencesConfirmationProps) {
    const intl = useIntl();
    const dispatch = useAppDispatch();

    const [isConfirmationVisible, setIsConfirmationVisible] = useState(true);

    const handleFieldChange = async () => {
        setIsConfirmationVisible(false);

        const res = await dispatch(updateCommunicationPreferenceConfirmation({ sectionName: type, householdId }));
        
        if(!res?.success) setIsConfirmationVisible(true);
        else resetCommunicationPrefCount?.();
    };

    if (!isConfirmationVisible) return null;

    return (
        <StyledPreferenceContainer data-testid={`preference_confirmation_${type?.toLowerCase()}`}>
            <FontAwesomeIcon icon={'info-circle'} className="text-danger" size="lg" />
            <Checkbox
                label={{
                    text: intl.formatMessage({ id: 'preferences_page.informationCorrect' }),
                }}
                inputData={{
                    checked: false,
                    type: 'checkbox',
                }}
                inputActions={{
                    handleFieldChange,
                }}
            />
        </StyledPreferenceContainer>
    );
}

export default PreferencesConfirmation;
